import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { IdentityService } from 'src/app/auth/identity.service';
import { DocumentiService } from 'src/app/core/documenti.service';
import { Direction, Documento } from 'src/app/shared/models/documento.model';
import { DocumentoProgressivo } from 'src/app/shared/models/documentoProgressivo.model';
import { DocumentoRiproduzioneRow } from 'src/app/shared/models/documentoRiproduzione.model';
import { Indirizzo } from 'src/app/shared/models/indirizzo.model';
import { StoricoStatoDocumento } from 'src/app/shared/models/storicoStatoDocumento.model';
import { NuovoDocumentoService } from '../../core/nuovo-documento.service';

@Component({
  selector: 'app-nuovo',
  template: `
  <div class="card card-w-title">
    <h1>Nuovo documento
    @if (direzione) {
      in {{direzione}}
    }
    </h1>
    @switch (activeStepIndex) {
      @case (0) {
        <div>
          <app-tipo-documento (tipoSelected)="tipoSelected($event)"></app-tipo-documento>
        </div>
      }
      @case (1) {
        <div>
          <app-position-select [allowCreation]="true" [noExpired]="true" [(ngModel)]="documento.gerarchia" #position="ngModel"></app-position-select>
          <button pButton type="button" label="Indietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()"></button>
          <button pButton type="button" label="Avanti" icon="fas fa-angle-right" style="float: right" (click)="next()" [disabled]="position.invalid"></button>
        </div>
      }
      @case (2) {
        <div>
          <app-dati-documento [(ngModel)]="documento" [posizione]="documento.gerarchia" #datiDoc="ngModel" [trasmissioneRiproduzione]="trasmissioneRiproduzione"
          [documentoRiproduzione]="documentoRiproduzione" [destinatariArray]="entiRichiedenti"></app-dati-documento>
          <button pButton type="button" label="Indietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()"></button>
          <button pButton type="button" label="Protocolla" icon="fas fa-stamp" style="float: right" (click)="protocolla()" [disabled]="datiDoc.invalid"></button>
        </div>
      }
      @case (3) {
        <div>
          <div class="registry-container">
            <h1>Numero di protocollo</h1>
            <p>{{progressivi?.[0]?.valore}}</p>
          </div>
          <button pButton type="button" label="Indietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()" [disabled]="true"></button>
          <button pButton type="button" label="Avanti" icon="fas fa-angle-right" style="float: right" (click)="next()"></button>
        </div>
      }
      @case (4) {
        <div>
          <div class="registry-container">
            <h1>Numero di carico</h1>
            <p>{{progressivi?.[1]?.valore}}</p>
          </div>
          <button pButton type="button" label="Indietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()" [disabled]="!progressivi?.[0]"></button>
          <button pButton type="button" label="Avanti" icon="fas fa-angle-right" style="float: right" (click)="next()"></button>
        </div>
      }
      @case (5) {
        <div>
          <div class="registry-container">
            <h1>Numero di controllo</h1>
            <p>{{progressivi?.[2]?.valore || '-'}}</p>
          </div>
          <button pButton type="button" label="Indietro" icon="fas fa-angle-left" class="p-button-secondary" (click)="previous()" [disabled]="!progressivi?.[0] && !progressivi?.[1]"></button>
          <button pButton type="button" label="Avanti" icon="fas fa-angle-right" style="float: right" (click)="next()"></button>
        </div>
      }
      @case (6) {
        <div>
          <!-- Riepilogo -->
          <div class="registry-container-small">
            <h1>Numero di protocollo</h1>
            <p>{{progressivi?.[0]?.valore || '-'}}</p>
          </div>
          <div class="registry-container-small">
            <h1>Numero di carico</h1>
            <p>{{progressivi?.[1]?.valore || '-'}}</p>
          </div>
          <div class="registry-container-small">
            <h1>Numero di controllo</h1>
            <p>{{progressivi?.[2]?.valore || '-'}}</p>
          </div>
          <button pButton type="button" label="Stampa etichetta" icon="fas fa-tag" (click)="printLabel()"></button>
          <button pButton type="button" label="Apri documento" icon="fas fa-angle-right" style="float: right" (click)="goToDocument()"></button>
        </div>
      }
    }
    <p-steps styleClass="mt-6" [model]="steps" [activeIndex]="activeStepIndex"></p-steps>
  </div>
  `,
  styles: [`
    .registry-container { text-align: center; }
    .registry-container > h1 { font-size: 2.5rem; font-weight: bold; }
    .registry-container > p { font-size: 5rem; }
    .registry-container-small { float: left; text-align: center; border-right: 1px solid #2EA563; width: 33.3%; }
    .registry-container-small:last-of-type { border-right: 0; }
    .registry-container-small > h1 { font-size: 1.5rem; font-weight: bold; }
    .registry-container-small > p { font-size: 4rem; }
  `]
})

export class NuovoComponent implements OnInit {
  public steps: MenuItem[];
  public activeStepIndex = 0;
  public documento!: Documento;
  public docIdArrivo: number | undefined;
  public direzione: Direction | undefined;
  public progressivi: DocumentoProgressivo[] | undefined;
  public documentoRiproduzione: DocumentoRiproduzioneRow | undefined;
  public entiRichiedenti: Indirizzo[] = [];
  public trasmissioneRiproduzione = false;
  public spedizioneRiproduzione = false;

  constructor(
    private nuovoDocumentoService: NuovoDocumentoService,
    private documentiService: DocumentiService,
    private confirmationService: ConfirmationService,
    private identityService: IdentityService,
    private router: Router,
    private messageService: MessageService
  ) {
    this.steps = [{ label: 'Tipo' }, { label: 'Posizione' }, { label: 'Dettagli' }, { label: 'Protocollo' }, { label: 'Carico', disabled: true }, { label: 'Controllo' }, { label: 'Riepilogo' }];
  }

  ngOnInit(): void {
    if (window.location.pathname.indexOf('nuova-partenza') > -1) {
      this.initNuovaPartenza();
      return;
    }

    if (window.location.pathname.indexOf('nuovo-in-fascicolo') > -1) {
      this.initNuovoInFascicolo();
      return;
    }

    if (window.location.pathname.indexOf('trasmetti-riproduzione') > -1) {
      this.initTrasmettiRiproduzione();
      return;
    }
    if (window.location.pathname.indexOf('trasmetti-originali') > -1) {
      this.initTrasmettiOriginali();
      return;
    }

    this.nuovoDocumentoService.init();
    this.documento = this.nuovoDocumentoService.documento;
    this.documento.gerarchia = this.nuovoDocumentoService.posizione;
    this.trasmissioneRiproduzione = false;
  }

  tipoSelected(direzione: Direction): void {
    this.direzione = direzione;
    this.documento = { ...this.documento, arrivo: (direzione === Direction.Arrivo) };
    if (window.location.pathname.indexOf('nuovo-in-fascicolo') > -1 && this.activeStepIndex === 0) {
      this.activeStepIndex = 2;
    } else {
      this.activeStepIndex++;
    }
  }

  next(): void {
    this.activeStepIndex++;

    const progressiviIndex = this.activeStepIndex - 3;
    if (progressiviIndex >= 0 && progressiviIndex < 3 && !this.progressivi?.[progressiviIndex]) {
      this.next();
    }
  }

  previous(): void {
    this.activeStepIndex--;

    const progressiviIndex = this.activeStepIndex - 3;
    if (progressiviIndex >= 0 && !this.progressivi?.[progressiviIndex]) {
      this.previous();
    }
  }

  goToSummary(): void {
    this.activeStepIndex = this.steps.length - 1;
  }

  goToDocument(): void {
    void this.router.navigateByUrl(`/visualizza/${this.documento.documentoId}`);
  }

  printLabel(): void {
    this.documentiService.printLabel(this.documento.documentoId);
  }

  protocolla(): void {
    this.confirmationService.confirm({
      message: 'Procedere con la protocollazione del documento?',
      acceptLabel: 'Protocolla',
      header: 'Protocollare?',
      accept: () => {
        let saveFunction: Observable<Documento>;

        if (window.location.pathname.indexOf('trasmetti-riproduzione') > -1) {
          if (!this.documentoRiproduzione) {
            this.messageService.add({ severity: 'error', summary: 'Errore', detail: 'Si è verificato un errore nella trasmissione della riproduzione.' });
            return;
          }

          saveFunction = this.documentiService.transmitRiproduzione(this.documento, this.documentoRiproduzione);
        } else if (window.location.pathname.indexOf('trasmetti-originali') > -1) {
          if (!this.docIdArrivo) {
            this.messageService.add({ severity: 'error', summary: 'Errore', detail: 'Errore nel recupero del documento di arrivo.' });
            return;
          }

          saveFunction = this.documentiService.trasmettiOriginali(this.docIdArrivo, this.documento);
        } else {
          const filteredGerarchia = this.documento.gerarchia.filter(l => l);
          this.documento.posizioneId = filteredGerarchia[filteredGerarchia.length - 1].posizioneId;
          this.documento.storicoStatiDocumento = [{ toStato: 1, timeStamp: new Date(), utente: this.identityService.userName } as StoricoStatoDocumento];
          saveFunction = this.documentiService.nuovoDocumento(this.documento);
        }

        saveFunction.subscribe(
          doc => {
            this.documento = doc;
            this.getProgressiviRegistri(doc.documentoProgressivo);
            this.nuovoDocumentoService.init();
            this.next();
          },
          () => {
            this.messageService.add({ severity: 'error', summary: 'Errore', detail: 'Si è verificato un errore durante il salvataggio' });
          }
        );
      }
    });
  }

  private getProgressiviRegistri(progressiviDocumento: DocumentoProgressivo[]) {
    this.progressivi = [];
    const progressivoPR = progressiviDocumento.find(p => p.progressivoKey.startsWith('Registro_PR'));
    if (!progressivoPR) {
      this.messageService.add({ severity: 'error', summary: 'Errore', detail: 'Si è verificato un errore nella generazione del numero di protocollo' });
      return;
    }

    this.progressivi.push(progressivoPR);

    const progressivoCA = progressiviDocumento.find(p => p.progressivoKey.startsWith('Registro_CA'));
    if (progressivoCA) {
      this.progressivi.push(progressivoCA);
    }

    const progressivoUC = progressiviDocumento.find(p => p.progressivoKey.startsWith('Registro_UC'));
    if (progressivoUC) {
      this.progressivi.push(progressivoUC);
    }
  }

  private initTrasmettiOriginali() {
    this.direzione = Direction.Partenza;
    this.activeStepIndex = 1;
    this.docIdArrivo = this.nuovoDocumentoService.docId;
    this.documento = this.nuovoDocumentoService.documento;
    this.documento.documentoDestinatario = [];
    this.documento.gerarchia = this.nuovoDocumentoService.posizione;
    this.trasmissioneRiproduzione = false;
  }

  private initTrasmettiRiproduzione() {
    if (this.nuovoDocumentoService.posizioneRiproduzione.length === 0) {
      void this.router.navigate(['/nuovo']);
    } else {
      this.activeStepIndex = 1;
    }
    this.documento = this.nuovoDocumentoService.documentoDaTrasmettere;
    this.documento.gerarchia = this.nuovoDocumentoService.posizioneRiproduzione;
    this.documentoRiproduzione = this.nuovoDocumentoService.documentoRiproduzione;
    this.entiRichiedenti = this.nuovoDocumentoService.entiRichiedenti;
    this.trasmissioneRiproduzione = true;
  }

  private initSpedisciRiproduzione() {
    if (this.nuovoDocumentoService.posizioneRiproduzione.length === 0) {
      void this.router.navigate(['/nuovo']);
    } else {
      this.activeStepIndex = 1;
    }
    this.documento = this.nuovoDocumentoService.documentoDaSpedire;
    this.documento.gerarchia = this.nuovoDocumentoService.posizioneRiproduzione;
    this.documentoRiproduzione = this.nuovoDocumentoService.documentoRiproduzione;
    this.spedizioneRiproduzione = true;
  }

  private initNuovaPartenza(): void {
    if (this.nuovoDocumentoService.documento.posizioneId) {
      this.activeStepIndex = 2;
    } else {
      void this.router.navigate(['/nuovo']);
    }
    this.documento = this.nuovoDocumentoService.documento;
    this.documento.classificaOriginaleId = this.documento.classificaId;
    this.documento.gerarchia = this.nuovoDocumentoService.posizione;
    this.trasmissioneRiproduzione = false;
    this.spedizioneRiproduzione = false;
  }

  private initNuovoInFascicolo() {
    if (this.nuovoDocumentoService.posizione.length === 0) {
      void this.router.navigate(['/nuovo']);
    } else {
      this.activeStepIndex = 0;
    }
    this.documento = this.nuovoDocumentoService.documento;
    this.documento.gerarchia = this.nuovoDocumentoService.posizione;
    this.trasmissioneRiproduzione = false;
    this.spedizioneRiproduzione = false;
  }
}
